module.exports = __webpack_public_path__ + "static/media/telecom.e1459a71.svg";